<template>
	<final-report
		:project-id="projectId"
		:readonly="false"
		:show-tables-export-button="true"
	/>
</template>

<script>
	import FinalReport from "./FinalReportComponent";

	export default {
		data() {
			return {
				projectId: this.$route.params.projectId,
			};
		},
		name: "FinalReportEditView",
		components: {FinalReport}
	};
</script>